import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "px-4 py-8 mt-8 sm:px-10"
}
const _hoisted_2 = { class: "flex min-h-full" }
const _hoisted_3 = { class: "flex flex-col justify-center flex-1 pb-12 mx-auto space-y-4 lg:flex-none" }
const _hoisted_4 = { class: "relative flex items-start" }
const _hoisted_5 = { class: "flex items-center h-8" }
const _hoisted_6 = ["id", "name", "value"]
const _hoisted_7 = { class: "ml-3 text-sm" }
const _hoisted_8 = ["for"]
const _hoisted_9 = { class: "font-normal text-clay-800 cursor-pointer" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "mt-2 ml-6"
}
const _hoisted_12 = { class: "space-y-5" }
const _hoisted_13 = { class: "sr-only" }
const _hoisted_14 = { class: "grid grid-cols-1 space-y-3 lg:grid-cols-3 lg:space-y-1" }
const _hoisted_15 = { class: "relative flex items-start" }
const _hoisted_16 = { class: "flex items-center h-5" }
const _hoisted_17 = ["id", "onUpdate:modelValue", "name", "value"]
const _hoisted_18 = { class: "ml-3 text-sm" }
const _hoisted_19 = ["for"]
const _hoisted_20 = { class: "py-3 mt-10 text-center" }

import {onMounted, Ref, ref} from "vue";
import {client} from '@/shared';
import {
    GetGoalsForOnboarding, 
    GetGoalsForOnboardingResponse,
    UpdateGoalsForOnboarding
} from "@/dtos";

// @ts-ignore
import {ResponseStatus} from "@servicestack/client";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import NotificationSuccess from "@/main/components/NotificationSuccess.vue";
import SkeletonCard from "@/main/components/skeletons/SkeletonCard.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingStepGoals',
  emits: ['onNext', 'onBack'],
  setup(__props, { emit: __emit }) {

// @ts-ignore
const goalsOptions = ref([
    { name: "Performers", description: "I want to prepare for auditions and improve performance skills",  value: "Performer", options: [], optionsSelected: []},
    { name: "Producers", description: "I'm a producer or artistic staff looking to promote auditions, performances and/or classes", value: "Artistic Staff", options: [], optionsSelected: []},
    { name: "Teachers", description: "I'm a teacher and am looking for resources", value: "Teacher", options: [], optionsSelected: []},
    { name: "Student", description: "I’m a student looking for materials for a class", value: "Student", options: [], optionsSelected: []},
    { name: "Fan", description: "I'm a fan who wants to learn more about theatre", value: "Fan", options: [], optionsSelected: []}
]);

const emit = __emit;

const isFetching = ref(true);
onMounted(async () => {
    await client.get<GetGoalsForOnboardingResponse>(new GetGoalsForOnboarding())
        .then(response => {
            getGoalsForOnboardingResponse.value = response;
            goalsOptions.value[0].options = getGoalsForOnboardingResponse.value.performerRolesOptions;
            goalsOptions.value[0].optionsSelected = getGoalsForOnboardingResponse.value.performerRoles;
            
            goalsOptions.value[1].options = getGoalsForOnboardingResponse.value.staffRolesOptions;
            goalsOptions.value[1].optionsSelected = getGoalsForOnboardingResponse.value.staffRoles;
            
            goalsOptions.value[2].options = getGoalsForOnboardingResponse.value.teacherRolesOptions;
            goalsOptions.value[2].optionsSelected = getGoalsForOnboardingResponse.value.teacherRoles;

            isFetching.value = false;
        });
});

const responseStatus = ref(null);
const getGoalsForOnboardingResponse: Ref<GetGoalsForOnboardingResponse> = ref({});
const updateSuccessful: Ref<Boolean> = ref(false);

const submit = async () => {

    updateSuccessful.value = false;
    let request = getGoalsForOnboardingResponse.value;
    request.performerRoles = goalsOptions.value[0].optionsSelected;
    request.staffRoles = goalsOptions.value[1].optionsSelected;
    request.teacherRoles = goalsOptions.value[2].optionsSelected;

    await client.post<ResponseStatus>(new UpdateGoalsForOnboarding(request))
        .then(_ => {
            updateSuccessful.value = true;
            responseStatus.value = null;
            emit('onNext');
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
};

const skip = async () => emit('onNext');


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ErrorSummary, { "response-status": responseStatus.value }, null, 8, ["response-status"]),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "sm:mx-auto sm:w-full sm:max-w-md" }, [
      _createElementVNode("h1", { class: "mt-6 text-3xl font-bold tracking-tight text-center text-gray-900" }, "What brings you to StageAgent?"),
      _createElementVNode("h2", { class: "mt-2 text-lg text-center text-gray-600" }, "Select all that apply")
    ], -1)),
    (isFetching.value)
      ? (_openBlock(), _createBlock(SkeletonCard, {
          key: 0,
          class: "mt-4",
          "card-style": "long",
          "num-of-cards": 2
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goalsOptions.value, (goalOption) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "p-6 bg-white border rounded-3xl border-clay-500",
                  key: goalOption.name
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _withDirectives(_createElementVNode("input", {
                        id: goalOption.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((getGoalsForOnboardingResponse.value.theatreRoles) = $event)),
                        name: goalOption.name,
                        value: goalOption.value,
                        "aria-describedby": "",
                        class: "w-4 h-4 rounded text-electric-600 border-clay-300 focus:ring-electric-500",
                        type: "checkbox"
                      }, null, 8, _hoisted_6), [
                        [_vModelCheckbox, getGoalsForOnboardingResponse.value.theatreRoles]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("label", {
                        for: goalOption.name,
                        class: "mb-2 text-lg font-medium text-gray-700 cursor-pointer"
                      }, [
                        _createTextVNode(_toDisplayString(goalOption.description) + " ", 1),
                        _createElementVNode("span", _hoisted_9, "(" + _toDisplayString(goalOption.name) + ")", 1)
                      ], 8, _hoisted_8)
                    ])
                  ]),
                  (getGoalsForOnboardingResponse.value.theatreRoles?.includes(goalOption.value))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (goalOption.options.length > 0)
                          ? (_openBlock(), _createElementBlock("dl", _hoisted_11, [
                              _createElementVNode("dd", null, [
                                _createElementVNode("fieldset", _hoisted_12, [
                                  _createElementVNode("legend", _hoisted_13, _toDisplayString(goalOption.name), 1),
                                  _createElementVNode("div", _hoisted_14, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goalOption.options, (o) => {
                                      return (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                        _createElementVNode("div", _hoisted_16, [
                                          _withDirectives(_createElementVNode("input", {
                                            id: o,
                                            "onUpdate:modelValue": ($event: any) => ((goalOption.optionsSelected) = $event),
                                            name: o,
                                            value: o,
                                            "aria-describedby": "",
                                            class: "w-4 h-4 border-2 border-gray-500 rounded text-clay-600 focus:ring-clay-500",
                                            type: "checkbox"
                                          }, null, 8, _hoisted_17), [
                                            [_vModelCheckbox, goalOption.optionsSelected]
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_18, [
                                          _createElementVNode("label", {
                                            for: o,
                                            class: "font-medium text-gray-700"
                                          }, _toDisplayString(o), 9, _hoisted_19),
                                          _cache[2] || (_cache[2] = _createTextVNode()),
                                          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-clay-800" }, null, -1))
                                        ])
                                      ]))
                                    }), 256))
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  class: "w-full inline-flex items-center justify-center px-4 py-[calc(theme(spacing.2)-1px)] rounded-full border border-transparent bg-electric-600 shadow-md whitespace-nowrap text-base font-medium text-white data-[disabled]:bg-clay-50 data-[hover]:bg-electric-500 data-[disabled]:text-clay-500",
                  type: "submit",
                  onClick: _withModifiers(submit, ["prevent"])
                }, " Next "),
                _createElementVNode("button", {
                  class: "justify-center hidden w-full px-4 py-2 mt-4 text-sm text-gray-600 underline hover:no-underline",
                  onClick: _withModifiers(skip, ["prevent","stop"])
                }, " Skip ")
              ]),
              _createElementVNode("button", {
                class: "justify-center w-full px-4 py-2 mt-4 text-sm text-gray-600 underline hover:no-underline",
                type: "submit",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => {emit('onBack');}, ["prevent"]))
              }, " Back ")
            ])
          ])
        ])),
    _createVNode(NotificationSuccess, {
      show: updateSuccessful.value,
      content: "Your changes were successfully saved.",
      title: "Successfully saved!"
    }, null, 8, ["show"])
  ], 64))
}
}

})